module.exports = __webpack_public_path__ + "static/media/bpmeasurex-carrying-case-3.435be607.png";